import script from "./Sunyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./Sunyuan.vue?vue&type=script&setup=true&lang=js"

import "./Sunyuan.vue?vue&type=style&index=0&id=27d3fa1a&lang=less&scoped=true"
script.__scopeId = "data-v-27d3fa1a"

export default script